"use client";
import React, { useEffect } from "react";
import { useSession } from "next-auth/react";

export function ClientSideUtils() {
  const { data: session } = useSession();

  useEffect(() => {
    const sendEventToExtension = async () => {
      if (session?.accessToken) {
        window.postMessage({ type: "CENTI_APP:IS_LOGGED_IN" }, "*");
      }
    };

    sendEventToExtension();
  }, []);

  return <div id="shopper-extension-anchor"></div>;
}
